import React, { useState } from "react";

export default React.memo(function TopTournamentMenuIcon(props: {
	sportAbrv: string;
	tournamentAbrv: string;
	isSpecialOffer?: boolean;
	urlIcon?: string;
	className: string;
	imgClassName?: string;
}) {
	const [errorSrcCount, setErrorSrcCount] = useState(-1);
	const [isLoading, setIsLoading] = useState(true);

	if (props.urlIcon) {
		return (
			<picture className={props.className}>
				<img
					// @ts-expect-error
					loading="lazy"
					className={props.imgClassName}
					src={"/assets/images/sportFallback.svg"}
					style={isLoading ? { opacity: "0" } : {}}
					onError={() => setErrorSrcCount(1 + errorSrcCount)}
					onLoad={() => setIsLoading(false)}
				/>
			</picture>
		);
	}

	const imagesUrls = [
		`${WEBPACK_CDN_ROOT_URL}/icons/sport/${props.tournamentAbrv}/${props.tournamentAbrv}.svg`,
		`${WEBPACK_CDN_ROOT_URL}/icons/sport/${props.sportAbrv}/${props.sportAbrv}.svg`,
	];
	if (props.isSpecialOffer) {
		imagesUrls.unshift(
			`${WEBPACK_CDN_ROOT_URL}/icons/sport/${props.sportAbrv}/special-offer/special-offer.svg`
		);
	}
	return (
		<>
			<picture className={props.className}>
				{imagesUrls
					.filter((_, idx) => {
						return idx > errorSrcCount;
					})
					.map((src, index) => (
						<source key={src + index} srcSet={src} />
					))}
				<img
					// @ts-expect-error
					loading="lazy"
					className={props.imgClassName}
					src={"/assets/images/sportFallback.svg"}
					style={isLoading ? { opacity: "0" } : {}}
					onError={() => setErrorSrcCount(1 + errorSrcCount)}
					onLoad={() => setIsLoading(false)}
				/>
			</picture>
		</>
	);
});
